import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/core/environment.service';
import { LocaleService } from '@app/core/services';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { ContactUsButtonComponent } from '@app/shared/components/contact-us/contact-us-button/contact-us-button.component';
import { SecureRedirectService } from '@app/core/services/secure-redirect/secure-redirect.service';
import { FeatureService } from '@app/core/services/feature.service';

@Component({
  selector: 'app-set-password-failure-page',
  templateUrl: './set-password-failure-page.component.html',
  styleUrls: ['./set-password-failure-page.component.scss'],
  imports: [NgClass, TranslateModule, ContactUsButtonComponent],
})
export class SetPasswordFailurePageComponent implements OnInit {
  private router = inject(Router);
  env = inject(EnvironmentService);
  private localeService = inject(LocaleService);
  private secureRedirect = inject(SecureRedirectService);
  private featureService = inject(FeatureService);
  hideSupportBt = false;

  private callback!: string;

  ngOnInit(): void {
    this.hideSupportBt =
      this.featureService.features.hideContactSupport.includes(
        this.localeService.getLanguageCode(),
      ) ?? false;
    if (history.state && history.state.data) {
      this.callback = this.secureRedirect.sanitizeUrl(history.state.data) ?? '';
    } else {
      window.location.href = this.env.getGlobalRedirectURI();
      this.redirect();
    }
  }

  /**
   * Retry reset password
   */
  retryReset() {
    this.router.navigate(['/forgot'], {
      queryParams: { redirect_uri: this.callback },
    });
  }

  /**
   * Redirect
   */
  private redirect() {
    window.location.href = this.callback;
  }
}
